import { useHistory, useLocation } from 'react-router-dom';
import { FC, useEffect } from 'react';
import useShepherdConfirm from 'hooks/useShepherdConfirm';
import qs from 'qs';

const ShepherdConfirmation: FC = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { tour } = useShepherdConfirm();
  const params: { confirmOrder?: string } = qs.parse(search, { ignoreQueryPrefix: true });

  useEffect(() => {
    tour?.on('complete', () => {
      const newSearch = { ...params };
      if ('confirmOrder' in newSearch) {
        delete newSearch.confirmOrder;
        history.replace({ pathname: location.pathname, search: qs.stringify(newSearch) });
      }
    });
    if (params && params.confirmOrder) {
      tour?.start();
    }
  }, []);

  return null;
};

export default ShepherdConfirmation;
